const state = {
  paginationListInfo: {
    rowsPerPage: 10
  },
  singleListSearch: ""
};

const getters = {
  getPaginationListInfo: state => state.paginationListInfo,
  getSingleListSearch: state => state.singleListSearch
};

const mutations = {
  UPDATE_PAGINATION_LIST_INFO(state, pagination) {
    state.paginationListInfo = pagination;
  },

  UPDATE_SINGLE_LIST_SEARCH(state, search) {
    state.singleListSearch = search;
  }
};

const actions = {
  updatePaginationListInfo({ commit }, pagination) {
    commit("UPDATE_PAGINATION_LIST_INFO", pagination);
  },
  updateSingleListSearch({ commit }, search) {
    commit("UPDATE_SINGLE_LIST_SEARCH", search);
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Management/PaginationAndSearch/listSettingsPaginationAndSearch.js